import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';
import { GetUserCertificateData, GetUserCertificateVar } from '../gql-types';

import GraphQL from '../gql';
import React from 'react'

let dashboardApolloClient: ApolloClient<NormalizedCacheObject> = null;
export function useCertificates(userkey: number) {

const {loading, error, data} = useQuery<GetUserCertificateData, GetUserCertificateVar>(GraphQL.Query.GET_USER_CERTIFICATES, {
    client: dashboardApolloClient,
    variables: {
        userkey
    },
    fetchPolicy: 'no-cache'
});

  return {
    loading,
    error,
    userCertificates: data?.getUserCertificates
  }
}
